import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import LandingPage from './components/LandingPage';
import NewReservation from './components/NewReservation';
import EditReservation from './components/EditReservation';
import AdminPanel from './components/AdminPanel';
import DevRoleSwitcher from './components/DevRoleSwitcher';

function App(): JSX.Element {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/new-reservation" element={<NewReservation />} />
            <Route path="/edit-reservation" element={<EditReservation />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
          {/* Staat buiten de routes zodat je vanaf elk scherm kunt terugwisselen. */}
          <DevRoleSwitcher />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
